import styled from 'styled-components';
import { Skeleton } from '@comeon/ui';

const SkeletonContainer = styled.div`
	background-color: var(--skeleton-placeholder-bg);
	height: 100%;
	width: 100%;
	grid-row: span 2;
	grid-column: span 2;
	display: flex;
	padding: 12px;
	border-radius: 12px;
	> div {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
`;

const ShopSkeleton = () => (
	<SkeletonContainer>
		<Skeleton height={170} width={250} borderRadius="6" />
		<div>
			<Skeleton height={12} width={100} margin={5} />
			<Skeleton height={18} width={150} margin={5} />
		</div>
	</SkeletonContainer>
);

export default ShopSkeleton;
